import { render } from "./Inputs.vue?vue&type=template&id=4402cf2d&ts=true"
import script from "./Inputs.vue?vue&type=script&lang=ts"
export * from "./Inputs.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__